import React from 'react'
import PropTypes from 'prop-types'
import Link from '@salesforce/retail-react-app/app/components/link'
import {Link as RouteLink} from 'react-router-dom'
import {ChevronRightIcon} from '../icons'
import {MenuCard} from './menu-card'
import {getContentstackTertiaryLink} from '../../utils/contentstack-utils'
import {useMultiStyleConfig} from '@chakra-ui/react'

const TertiaryLink = ({link, categoriesData, asSecondaryCard = false}) => {
    const styles = useMultiStyleConfig('ListMenu')

    const {url, displayName} = getContentstackTertiaryLink(link, categoriesData)

    if (asSecondaryCard) {
        return (
            <MenuCard title={displayName} url={url} image={link?.icon} isLink variant="secondary" />
        )
    }

    return (
        <Link as={RouteLink} to={url} {...styles.tertiaryLink}>
            {displayName}
            <ChevronRightIcon boxSize="iconsSize.small" />
        </Link>
    )
}

TertiaryLink.propTypes = {
    link: PropTypes.object,
    categoriesData: PropTypes.object,
    asSecondaryCard: PropTypes.bool,
}

export default TertiaryLink
